import React, { useEffect, useState } from "react";
import { Column } from "@ant-design/charts";
import { Button, Modal } from "semantic-ui-react";

const RCPDonut = ({ data, year, key_find, analysis, unitType = "dollar" }) => {
  const [openModal, setOpenModal] = useState(false);
  const [chartData, setChartData] = useState([]);
  const [yMax, setYMax] = useState(0);

  useEffect(() => {
    if (!data) return;

    const rcpList = ["2.6", "4.5", "8.5"];
    const transformed = [];
    const maxCVaR = data.cvar[unitType]?.year_max || 0;
    const maxRCVaR = data.rcvar[unitType]?.year_max || 0;
    const maxY = Math.max(maxCVaR, maxRCVaR);
    setYMax(maxY); // <- Store max for later use

    rcpList.forEach((rcp) => {
      transformed.push(
        {
          type: "CVaR",
          RCP: rcp,
          value: parseFloat(
            data.cvar[unitType]?.year_constant?.[rcp]?.toFixed(2) || 0
          ),
        },
        {
          type: "RCVaR",
          RCP: rcp,
          value: parseFloat(
            data.rcvar[unitType]?.year_constant?.[rcp]?.toFixed(2) || 0
          ),
        }
      );
    });

    setChartData(transformed);
  }, [data, unitType]);

  const yAxisTitle =
    unitType === "dollar" ? "Loss in Million USD" : "Loss in % ";

  const config = {
    data: chartData,
    isGroup: true,
    xField: "RCP",

    dodgePadding: 5,
    yField: "value",
    yAxis: {
      max: 1.25 * yMax,
      title: {
        text: yAxisTitle,
      },
    },
    seriesField: "type",
    color: ["#BFCDF6", "#1A3670"],

    label: {
      content: (originData) => originData.value.toFixed(2),

      position: "top",

      style: {
        fontSize: 10,
      },
      ///layout: [{ type: "interval-adjust-position" }, { type: "adjust-color" }],
    },
    legend: {
      position: "top",
    },
    minColumnWidth: 30,
    maxColumnWidth: 30,
  };

  const formatValue = (val) => {
    if (unitType === "dollar") {
      return `US$ ${parseFloat(val).toFixed(2)} Million`;
    } else {
      return `${parseFloat(val).toFixed(2)}%`;
    }
  };

  return (
    <div>
      <Column {...config} />

      <Button
        style={{
          color: "#18202F",
          backgroundColor: "white",
          borderColor: "#18202F",
          border: "1px solid",
          marginTop: "10px",
        }}
        onClick={() => setOpenModal(true)}
      >
        Key Findings
      </Button>
      <Modal open={openModal} onClose={() => setOpenModal(false)} closeIcon>
        <Modal.Header style={{ backgroundColor: "white" }}>
          Key Findings
        </Modal.Header>
        <Modal.Content>
          {key_find ? (
            <p className="key_finding">
              For the given year {year}, the projected loss depends on the
              carbon concentration, captured by certain {analysis.toUpperCase()}
              s. The difference between {analysis.toUpperCase()}&nbsp;8.5 and{" "}
              {analysis.toUpperCase()} 2.6 reflects the Value of Transition
              Policies which is{" "}
              <span className="key_find">
                {formatValue(key_find.value_of_transition_policies)}
              </span>{" "}
              by {year}. This is calculated by the difference between{" "}
              {analysis.toUpperCase()} 8.5 CVaR of{" "}
              <span className="key_find">{formatValue(key_find.cvar_85)}</span>{" "}
              and {analysis.toUpperCase()} 2.6 CVaR of{" "}
              <span className="key_find">{formatValue(key_find.cvar_26)}</span>.
            </p>
          ) : null}
        </Modal.Content>
      </Modal>
    </div>
  );
};

export default RCPDonut;
